/**
 * Basit bot tespiti. Tracker init sirasinda bir kez calisir;
 * bot tespit edilirse hicbir event gonderilmez.
 */
const BOT_UA_REGEX =
    /bot|crawler|crawl|spider|slurp|mediapartners|adsbot|bingpreview|facebookexternalhit|whatsapp|telegrambot|semrush|ahrefs|mj12|dotbot|petalbot|yandex|baidu|duckduck|pingdom|gtmetrix|lighthouse|headless|phantomjs|puppeteer|playwright|python-requests|curl\/|wget|scrapy|monitoring/i;

export function isBot() {
    try {
        const ua = navigator.userAgent || "";
        if (!ua) return true;
        if (BOT_UA_REGEX.test(ua)) return true;
        if (navigator.webdriver === true) return true;
        // Headless Chrome'da genelde dil listesi bos gelir
        if (navigator.languages && navigator.languages.length === 0) return true;
        return false;
    } catch (e) {
        return false;
    }
}

export default isBot;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/botDetect.js
// module id = null
// module chunks = 